import { action, observable, runInAction } from 'mobx';
import ordersController from '../controller';
import type {
  PhotoListItem, FileCheckItem,
} from '../../api/photoApi';
// import { getOrderPhotos } from '../controller';
import cloneDeep from 'lodash/cloneDeep';

export interface PhotoStore {
  photoList: PhotoListItem[],
  fileCheckItems: FileCheckItem[],
  error: any,
}

export const photoStore: PhotoStore = observable({
  photoList: [],
  fileCheckItems: [],
  error: null,
} as PhotoStore);

export const photoActions = {

  getOrderPhotos: async (request: any): Promise<void> => {
    photoStore.error = null;
    const response = await ordersController.getOrderPhotos(request.orderId, request.showDeleted);
    photoActions.handleError(response);
    photoStore.photoList = response.data;
  },

  clearOrderPhotos: action(() => {
    photoStore.photoList = [];
  }),

  handleError: action((response) => {
    if (response.errorData) {
      const { data } = response;
      photoStore.error = data;
      throw data;
    }
  }),

  // Блок проверки загрузки фото в бакеты
  pushFileCheckItems: async (request: FileCheckItem[]): Promise<void> => {
    photoStore.fileCheckItems = request;
  },

  clearFileCheckItems: action((): void => {
    photoStore.fileCheckItems = [];
  }),

  setFileId: action((indexId: number, value: string): void => {
    const x = cloneDeep(photoStore.fileCheckItems);
    x[indexId].fileId = value;
    photoStore.fileCheckItems = x;
  }),

  checkOrderFile: async (indexId: number): Promise<void> => {
    const fileId = photoStore.fileCheckItems[indexId].fileId;
    if (fileId) {
      photoStore.error = null;
      const response = await ordersController.checkOrderFile(fileId);
      photoActions.handleError(response);
      if (response?.data?.success) {
        const x = cloneDeep(photoStore.fileCheckItems);
        x[indexId].checked = true;
        runInAction(() => { photoStore.fileCheckItems = x; });
      }
    };
  },

  // Конец блока проверки загрузки фото в бакеты
};
